import React, { useRef, useState } from "react";
import { Button, Modal, Overlay, Tooltip } from "react-bootstrap";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { useNavigate } from "react-router-dom";

const GenerateModal = ({
  showModal = false,
  setShowModal = () => {},
  username = "",
  password = "",
  isCreated = false,
}) => {
  const [show, setShow] = useState({
    username: false,
    password: false,
  });
  const usertarget = useRef(null);
  const passwordtarget = useRef(null);
  const navigate = useNavigate();

  const handleCloseModal = () => {
    setShowModal(false);
    navigate(-1);
  };

  const handleCopyClick = async (textToCopy) => {
    try {
      await navigator.clipboard.writeText(textToCopy);
    } catch (err) {
      console.error("Unable to copy text:", err);
    }
  };
  return (
    <div>
      <Modal show={showModal} onHide={handleCloseModal}>
        <Modal.Header>
          <Modal.Title>Generated Credentials</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="d-flex">
            {isCreated ? (
              <>
                <div className="px-3">
                  <p>Username:- {username}</p>
                </div>
                <div
                  ref={usertarget}
                  onClick={() => {
                    handleCopyClick(username);
                    setShow({
                      ...show,
                      username: !show?.username,
                    });
                    setTimeout(() => {
                      setShow((prevShow) => ({
                        ...prevShow,
                        username: false,
                      }));
                    }, 1000);
                  }}
                >
                  <ContentCopyIcon className="cursor-pointer" />
                </div>
              </>
            ) : null}
            <div>
              <p className="px-3">Password: {password}</p>
            </div>
            <div
              ref={passwordtarget}
              onClick={() => {
                handleCopyClick(password);
                setShow({
                  ...show,
                  password: !show?.password,
                });
                setTimeout(() => {
                  setShow((prevShow) => ({
                    ...prevShow,
                    password: false,
                  }));
                }, 1000);
              }}
            >
              <ContentCopyIcon className="cursor-pointer" />
            </div>
          </div>

          <Overlay
            target={usertarget.current}
            show={show?.username}
            placement="right"
          >
            {(props) => (
              <Tooltip id="overlay-example" {...props}>
                Copied Text!
              </Tooltip>
            )}
          </Overlay>
          <Overlay
            target={passwordtarget.current}
            show={show?.password}
            placement="right"
          >
            {(props) => (
              <Tooltip id="overlay-example" {...props}>
                Copied Text!
              </Tooltip>
            )}
          </Overlay>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModal}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default GenerateModal;
